import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "hotels-modal-search" }
const _hoisted_2 = { class: "hotels-modal-search__tabs" }
const _hoisted_3 = /*#__PURE__*/_createVNode("label", {
  class: "hotels-modal-search__tabs-label",
  for: "all-services"
}, "Все сервисы", -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("form", _hoisted_2, [
      _createVNode("input", {
        class: "hotels-modal-search__tabs-input",
        type: "radio",
        name: "services",
        id: "all-services",
        value: "Все сервисы",
        checked: "",
        onChange: _cache[1] || (_cache[1] = $event => (_ctx.setService(null)))
      }, null, 32),
      _hoisted_3,
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.shortAccesor, (acc) => {
        return (_openBlock(), _createBlock(_Fragment, {
          key: acc.id
        }, [
          _createVNode("input", {
            class: "hotels-modal-search__tabs-input",
            type: "radio",
            name: "services",
            id: acc.id,
            value: acc.id,
            onChange: $event => (_ctx.setService(acc.id))
          }, null, 40, ["id", "value", "onChange"]),
          _createVNode("label", {
            class: "hotels-modal-search__tabs-label",
            for: acc.id
          }, _toDisplayString(acc.name), 9, ["for"])
        ], 64 /* STABLE_FRAGMENT */))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}